import { EmptyControl } from '@hvlng/framework-bff/core';
import { JsonObject, JsonProperty } from 'json2typescript';
import { HvlDateConverter } from '@hvlng/framework-bff/util';
import { CodeTextQueryModel } from '../../code-text/model/code-text-query-model';

@JsonObject('KovanHrTimeConstrainedCodeTextQueryModel')
export class TimeConstrainedCodeTextQueryModel extends CodeTextQueryModel {
    @EmptyControl()
    @JsonProperty('beginDate', HvlDateConverter, true)
    beginDate?: Date = null;

    @EmptyControl()
    @JsonProperty('endDate', HvlDateConverter, true)
    endDate?: Date = null;

    @EmptyControl()
    @JsonProperty('reverseBeginDateEndDateCheck', Boolean, true)
    reverseBeginDateEndDateCheck?: boolean = null;
}
